"use strict";

var _lang = _interopRequireDefault(require("./lang"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var currency = document.querySelector('html').dataset.currency;
module.exports = function (value) {
  return parseFloat(value).toLocaleString(_lang["default"], {
    style: 'currency',
    currency: currency
  });
};